import React from 'react'
import ReactModal from 'react-modal'
import { isEmpty } from 'lodash'

export const DialogModal = ({
  autoHandleCloseModal = true,
  className,
  closeModalCallback,
  confirmationCallback,
  isCancelButton = true,
  modalBody,
  modalButtonText,
  modalIsOpen,
  modalTitle,
}) => {
  const handleCloseModal = () => {
    closeModalCallback(false)
  }

  const handleDialogModalConfirmation = () => {
    confirmationCallback()

    autoHandleCloseModal && handleCloseModal()
  }

  return (
    <ReactModal
      className={`dialog-modal ${className}`}
      isOpen={modalIsOpen}
      onRequestClose={handleCloseModal}
      overlayClassName='dialog-modal-overlay'
    >
      {!isEmpty(modalTitle) && (
        <div className="dialog-modal__header">
          <h3>{modalTitle}</h3>
        </div>
      )}
      <div className="dialog-modal__body">{modalBody}</div>
      {(isCancelButton || !isEmpty(modalButtonText)) && (
        <div className="dialog-modal__actions">
          {isCancelButton && (
            <button
              className="dialog-modal__actions__btn btn-cancel"
              type="button"
              onClick={handleCloseModal}>
              cancel
            </button>
          )}
          {!isEmpty(modalButtonText) && (
            <button
              className="dialog-modal__actions__btn btn-confirm"
              type="button"
              onClick={handleDialogModalConfirmation}>
              {modalButtonText}
            </button>
          )}
        </div>
      )}
    </ReactModal>
  )
}
